import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { NoFilterResults } from "../../../../components/Filter/NoFilterResults/NoFilterResults";
import { useUserFilter } from "../../../../hooks/filters/useUserFilter";
import { UserContext } from "../../../../providers/UserContextProvider";
import { UserListItem } from "../UserListItem/UserListItem";
function UserList() {
    const { state: { users }, } = useContext(UserContext);
    const { filterUsers } = useUserFilter();
    const filteredUsers = users.filter(filterUsers);
    if (users && users.length === 0) {
        return _jsx(NoFilterResults, { text: __("No users found", "quicktasker") });
    }
    if (filteredUsers && filteredUsers.length === 0) {
        return _jsx(NoFilterResults, {});
    }
    return (_jsx("div", { className: "wpqt-card-grid", children: filteredUsers.map((user) => {
            return _jsx(UserListItem, { user: user }, user.id);
        }) }));
}
export { UserList };
